import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const FooterContainer = styled.footer`
  background: var(--neutral-100);
  border-top: 1px solid var(--neutral-200);
  margin-top: auto;
`;

const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: var(--space-6) var(--space-4);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-4);

  @media (min-width: 768px) {
    flex-direction: row;
    justify-content: space-between;
  }
`;

const Logo = styled(Link)`
  font-size: var(--text-xl);
  font-weight: 700;
  font-family: var(--font-serif);
  color: var(--primary-800);
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: var(--space-2);
  
  &:hover {
    color: var(--primary-900);
    text-decoration: none;
  }
`;

const LogoIcon = styled.span`
  width: 28px;
  height: 28px;
  background: linear-gradient(135deg, var(--primary-600) 0%, var(--primary-800) 100%);
  border-radius: var(--radius-md);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: var(--text-sm);
  font-weight: bold;
`;

const LegalLinks = styled.div`
  display: flex;
  gap: var(--space-6);
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;

  @media (min-width: 768px) {
    justify-content: flex-end;
  }
`;

const LegalLink = styled(Link)`
  font-size: var(--text-sm);
  color: var(--neutral-600);
  font-weight: 500;
  transition: color var(--transition-fast);

  &:hover {
    color: var(--primary-700);
    text-decoration: none;
  }
`;

const Footer = () => {
  return (
    <FooterContainer>
      <FooterContent>
        <Logo to="/">
          <LogoIcon>I</LogoIcon>
          Intellica
        </Logo>

        <LegalLinks>
          <LegalLink to="/about">About</LegalLink>
          <LegalLink to="/privacy">Privacy Policy</LegalLink>
          <LegalLink to="/terms">Terms of Service</LegalLink>
        </LegalLinks>
      </FooterContent>
    </FooterContainer>
  );
};

export default Footer;